import { CartItem, CartOrder, CartOrderDetailsIndex, CartPlacedOrder } from '@/models/cart';
import { Company } from '@/models/company';

export interface CartState {
  cartId: string;
  orders: CartOrder[];
  cartCountOverride: number | null; // Temporary override for cart count while it updates
  cartItemCount: number;
  orderDetails: CartOrderDetailsIndex;
  companies: Company[];
  isLoading: boolean;
  isLoaded: boolean;
  items: CartItem[];
  validationErrors: string[];
  placedOrders: CartPlacedOrder[];
  isUpdatingCart: boolean;
  // Adding to deal with reactivity issue in CartCheckout component
  hasPaymentOnSellThroughError: boolean;
}

export const state: CartState = {
  cartId: '',
  orders: [],
  cartCountOverride: null,
  cartItemCount: 0,
  companies: [],
  isLoading: true,
  isLoaded: false,
  items: [],
  orderDetails: {},
  validationErrors: [],
  placedOrders: [],
  isUpdatingCart: false,
  hasPaymentOnSellThroughError: false,
};
